module.exports = __webpack_public_path__ + "static/media/home-ecommerce-logos.8e472de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-ecommerce-logos.png
// module id = 266
// module chunks = 0